import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, BrainIcon, SectionDivider } from './Icons';
export const AgitationSection = () => {
  return <section className="py-16 px-4 md:px-8 bg-brand-creamAlt" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-green text-center mb-8" data-id="element-18">
            Es frustrante.
          </h2>

          <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-19">
            <div className="space-y-6 text-lg text-brand-charcoal/90" data-id="element-20">
              <p data-id="element-21">
                Has intentado comer menos, has eliminado los carbohidratos, te
                has apuntado al gimnasio... y lo único que has conseguido es
                estar más cansada, más irritable y, sorprendentemente, más
                inflamada.
              </p>
              <p data-id="element-22">
                La "Cultura de la Dieta" te ha mentido durante décadas
                diciéndote que la salud es una cuestión de matemáticas: calorías
                que entran por calorías que salen.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-brand-crimson" data-id="element-23">
              <p className="font-serif text-2xl font-bold text-brand-charcoal italic" data-id="element-24">
                "Pero a los 45 años, la matemática muere y la bioquímica toma el
                control."
              </p>
            </div>
          </div>

          <div className="mt-12 bg-white p-8 rounded-2xl shadow-sm space-y-6 relative overflow-hidden" data-id="element-25">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/5 rounded-bl-full -z-10" data-id="element-26"></div>

            <div className="flex items-start gap-4" data-id="element-27">
              <div className="mt-1 bg-brand-cream p-3 rounded-full text-brand-crimson" data-id="element-28">
                <FlameIcon className="w-6 h-6" data-id="element-29" />
              </div>
              <p className="text-lg text-brand-charcoal/90" data-id="element-30">
                Cada vez que te fuerzas a una dieta restrictiva, tu Cortisol (la
                hormona del estrés) se dispara. Para tu cuerpo, estás en
                peligro, y su respuesta es lógica: almacenar grasa abdominal
                para protegerte...
              </p>
            </div>

            <div className="flex items-start gap-4" data-id="element-31">
              <div className="mt-1 bg-brand-cream p-3 rounded-full text-brand-green" data-id="element-32">
                <BrainIcon className="w-6 h-6" data-id="element-33" />
              </div>
              <p className="text-lg text-brand-charcoal/90" data-id="element-34">
                ...y apagar tu claridad mental para ahorrar energía. Estás
                atrapada en un ciclo de "Supervivencia Hormonal" donde el
                esfuerzo solo empeora el resultado.
              </p>
            </div>

            <div className="pt-6 text-center" data-id="element-35">
              <h3 className="text-2xl font-serif font-bold text-brand-crimson uppercase tracking-wide" data-id="element-36">
                Es hora de romper el ciclo.
              </h3>
            </div>
          </div>
        </motion.div>

        <SectionDivider data-id="element-37" />
      </div>
    </section>;
};